// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80a8875a","453":"d37606ba","667":"23b48ef8","977":"75fe7ead"}[chunkId] + ".chunk.js";
};